export const PROMPT_BRIDGE_ASSISTANT_AVAILABILITY_TAG =
  'PromptBridgeAssistantAvailability' as const;
